import { useTranslate } from "@similarweb/i18n-provider";
import { Dropdown, IconButton, SimpleDropdownItem } from "@similarweb/ui-components";

import {
    MY_INTEGRATIONS_ADD_BUTTON,
    MY_INTEGRATIONS_ADD_OPTION_MCP,
} from "app/pages/sales-intelligence/modules/manage-integrations/constants/translations";
import siNavigator from "app/pages/sales-intelligence/services/siNavigator";
import {
    MANAGEMENT_APIS_AND_WEBHOOKS,
    MANAGEMENT_CRMS_LABEL,
} from "app/pages/sales-intelligence/pages/management/translations/managementKeys";

const ADD_OPTION_ID = {
    crm: "crm",
    apisWebhooks: "apis-webhooks",
    mcp: "mcp",
} as const;

type AddOptionId = (typeof ADD_OPTION_ID)[keyof typeof ADD_OPTION_ID];

const NAVIGATE_BY_OPTION: Record<AddOptionId, VoidFunction> = {
    [ADD_OPTION_ID.crm]: () => {
        void siNavigator.goToCrmIntegrationsPage();
    },
    [ADD_OPTION_ID.apisWebhooks]: () => {
        void siNavigator.goToAPIsWebhooksPage();
    },
    [ADD_OPTION_ID.mcp]: () => {
        void siNavigator.goToMCPServersPage();
    },
};

interface ISelectedItem {
    id: AddOptionId;
}

const AddIntegrationDropdown = (): React.ReactElement => {
    const { translate } = useTranslate();

    const handleSelect = (item: ISelectedItem) => {
        const navigate = NAVIGATE_BY_OPTION[item.id];

        if (navigate) {
            navigate();
        }
    };

    return (
        <div>
            <Dropdown
                onClick={handleSelect}
                closeOnItemClick
                closeOnClickOut
            >
                <IconButton
                    key="add-integration-button"
                    type="primary"
                    iconName="add"
                    data-automation="my-integrations-add-button"
                >
                    {translate(MY_INTEGRATIONS_ADD_BUTTON)}
                </IconButton>
                <SimpleDropdownItem
                    key={ADD_OPTION_ID.crm}
                    id={ADD_OPTION_ID.crm}
                >
                    {translate(MANAGEMENT_CRMS_LABEL)}
                </SimpleDropdownItem>
                <SimpleDropdownItem
                    key={ADD_OPTION_ID.apisWebhooks}
                    id={ADD_OPTION_ID.apisWebhooks}
                >
                    {translate(MANAGEMENT_APIS_AND_WEBHOOKS)}
                </SimpleDropdownItem>
                <SimpleDropdownItem
                    key={ADD_OPTION_ID.mcp}
                    id={ADD_OPTION_ID.mcp}
                >
                    {translate(MY_INTEGRATIONS_ADD_OPTION_MCP)}
                </SimpleDropdownItem>
            </Dropdown>
        </div>
    );
};

export default AddIntegrationDropdown;
